module.exports = __webpack_public_path__ + "img/organizationalUnit.69e5d9b7.svg";